<p-toast [style]="{marginTop: '0px'}" key="ft-toast"></p-toast>

<nb-card style="width: 100%; margin-bottom: 0px; height: 100%">
  <nb-card-header *ngIf="fieldTask.fieldTaskId == null || fieldTask.fieldTaskId
    == undefined">
    Add Task
  </nb-card-header>
  <nb-card-header *ngIf="fieldTask.fieldTaskId !== null && fieldTask.fieldTaskId
    !== undefined">
    <h3>Edit Task</h3>
  </nb-card-header>
  <nb-card-body [nbSpinner]="(!farmsLoaded || !fieldEventTypesLoaded)" style="max-height: 200px;overflow: scroll;">

    <div *ngIf="this.farmsLoaded == true && this.fieldEventTypesLoaded == true">
      <form #fieldTaskForm="ngForm" (ngSubmit)="onSubmit(formDirective)"
        id="fieldTaskForm" #formDirective="ngForm">
        <div class="container">
          <div class="row">
            <div class="col">
              <!-- Event Type -->
              <div class="row">
                <div class="col">
                  <mat-form-field>
                    <mat-label>Event Type</mat-label>
                    <mat-select name="selectedFieldEventType"
                      id="selectedFieldEventType"
                      #selectedFieldEventType="ngModel"
                      [(ngModel)]="fieldTask.requestedFieldEventTypeId"
                      required>
                      <mat-option *ngFor="let et of fieldEventTypesSelect"
                        [value]="et.id">
                        {{et.name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <div *ngIf="selectedFieldEventType.invalid && (saveAttempted)"
                    class="alert alert-danger">
                    <div *ngIf="selectedFieldEventType.hasError('required')">
                      Event type is required.
                    </div>
                  </div>
                </div>
              </div>

              <!-- Start Date-->
              <div class="row">
                <div class="col">
                  <mat-form-field>
                    <input matInput [nbDatepicker]="startDatePicker"
                      placeholder="Start date"
                      [(ngModel)]="fieldTask.startDate" id="startDate"
                      name="startDate" #startDate="ngModel">
                    <!-- <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle> -->
                    <nb-datepicker #startDatePicker></nb-datepicker>
                  </mat-form-field>
                </div>
              </div>

              <!-- due date-->
              <div class="row">
                <div class="col">
                  <mat-form-field>
                    <input matInput [nbDatepicker]="dueDatePicker"
                      placeholder="Due date" required
                      [(ngModel)]="fieldTask.dueDate" id="dueDatePicker"
                      name="dueDatePicker" #dueDatePicker="ngModel">
                    <!-- <mat-datepicker-toggle matSuffix [for]="dueDatePicker"></mat-datepicker-toggle> -->
                    <nb-datepicker #dueDatePicker></nb-datepicker>
                  </mat-form-field>
                </div>
                <div *ngIf="dueDatePicker.invalid && (saveAttempted)"
                  class="alert alert-danger">
                  Due date is required
                </div>
              </div>

              <!-- Comment -->
              <div class="row" *ngIf="fieldTask !== null && fieldTask !==
                undefined">
                <mat-form-field class="col">
                  <textarea matInput placeholder="Comments"
                    [(ngModel)]="fieldTask.requestorComments"
                    name="requestorComments"
                    id="requestorComments"
                    [value]="fieldTask?.requestorComments"
                    #requestorComments="ngModel"></textarea>
                </mat-form-field>
              </div>


            </div>
            <mat-divider [vertical]="true"></mat-divider>
            <!-- blocks-->
            <div class="col">
              <h4 class="row">
                <div class="col">
                  <button type="button" mat-button
                    (click)="openBlockSelectDialog()">
                    {{"Blocks" | tenantWords}}
                    <fa-icon [icon]="faPlusCircle"></fa-icon>
                  </button>
                </div>
              </h4>

              <div class="row">
                <!-- <perfect-scrollbar class="m-scrollable m-scroller"
                  style="max-height: 30vh;"> -->
                  <mat-list dense>
                    <mat-list-item *ngIf="fieldTask.requestedBlocks.length ==
                      0">
                      <p>All</p>
                    </mat-list-item>
                    <mat-list-item matInput *ngFor="let block of
                      fieldTask.requestedBlocks">
                      <h4 mat-line>{{block.name}}</h4>
                      <p mat-line>{{block.varietyName}}</p>
                    </mat-list-item>
                  </mat-list>
                <!-- </perfect-scrollbar> -->
              </div>
            </div>

            <!-- Assigned Users -->
            <div class="col">
              <h4 class="row">
                <div class="col">
                  <button type="button" mat-button
                    (click)="openUserSelectDialog()">
                    Assigned Users
                    <fa-icon [icon]="faPlusCircle"></fa-icon>
                  </button>
                </div>
              </h4>

              <div class="row">
                <!-- <perfect-scrollbar class="m-scrollable m-scroller"
                  style="max-height: 30vh;"> -->
                  <mat-list dense>
                    <mat-list-item *ngIf="selectedUsersList.length == 0">
                      <p mat-line>All</p>
                    </mat-list-item>
                    <mat-list-item *ngFor="let user of selectedUsersList">
                      <p mat-line>{{user.name}}</p>
                    </mat-list-item>
                  </mat-list>
                <!-- </perfect-scrollbar> -->
              </div>
            </div>

          </div>

          <mat-divider></mat-divider>
          <!-- save button area -->
          <div class="row">
            <div class="save-button-div" *ngIf="!isSaving">
              <button mat-raised-button color="primary" type="submit">Save</button>
            </div>
            <div style="margin-left: 15px; margin-top: 11px;" class="col d-flex
              align-items-center justify-content-start">
              <a *ngIf="fieldTask.fieldTaskId !== undefined" mat-button [routerLink]="['/field-tasks/ft-report']">Cancel</a>
            </div>
            <mat-progress-bar *ngIf="isSaving" mode="query"></mat-progress-bar>
          </div>
        </div>
      </form>
    </div>
  </nb-card-body>

</nb-card>